import { render } from "./group-domains-action.vue?vue&type=template&id=a10ca5c8"
import script from "./group-domains-action.vue?vue&type=script&lang=js"
export * from "./group-domains-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__